module.exports = __webpack_public_path__ + "static/media/08.11.a5617977.webp";